<div class="price">
  <div class="left">
    {{integerPart}}
  </div>
  <div class="right">
    <div class="currency">€</div>
    <div class="decimals">{{decimalPart}}</div>
  </div>
</div>